import React, { createContext, useContext, useEffect, useState } from "react";
import { format, startOfMonth, endOfMonth, isValid, parseISO } from "date-fns";

const PlanningPeriodContext = createContext(null);
export const monthPeriod = (day = new Date()) => ({ date_from: format(startOfMonth(day), "yyyy-MM-dd"), date_to: format(endOfMonth(day), "yyyy-MM-dd") });

export function PlanningPeriodProvider({ children }) {
  const [period, setPeriod] = useState(() => monthPeriod());
  const query = new URLSearchParams(period).toString();
  return <PlanningPeriodContext.Provider value={{ period, setPeriod, query, label: `${period.date_from} t/m ${period.date_to}` }}>{children}</PlanningPeriodContext.Provider>;
}
export const usePlanningPeriod = () => useContext(PlanningPeriodContext);
